import { Option } from '../components/common/SearchSelect';

export const convertToOption = (id: any, label?: any): Option<any> => (label ? { id, label } : { id, label: id });
export const enumConvertToOption = (obj: object) =>
	Object.keys(obj).map((status) => {
		return { id: status, label: status };
	});
